import GoogleSourceBtn from "@components/GoogleSourceBtn/GoogleSourceBtn";
import { useRouteResponse } from "@src/app/hooks/useRouteResponse";
import viewportState from "@src/app/stores/viewport";
import dayjs from "dayjs";
// import type { BFFArticleBodyElement } from "@src/app/types/bff";
import { useSnapshot } from "valtio";

import CategoryTag from "../CategoryTag";
import DescriptionTag from "../DescriptionTag";
import SocialShare from "../SocialShare/SocialShare";

export default function ArticleHeaderSection() {
  const { article } = useRouteResponse("articlePage");
  const { created = "", sectionName, section } = article || {};

  const formattedPublishDate = created
    ? dayjs(created).format("D MMM YYYY")
    : "";

  const { isDesktopView } = useSnapshot(viewportState);

  const descriptionTag =
    article?.displayType === "big_read"
      ? "BigRead"
      : article?.displayType === "photo_story"
        ? "PhotoStory"
        : undefined;

  return (
    <div className="dark:text-primary-on-dark mx-3 mb-8 lg:mb-4">
      {descriptionTag ? (
        <div className="hidden pt-4 lg:block">
          <DescriptionTag name={descriptionTag} />
        </div>
      ) : null}

      {/* Header */}
      {/* id is read by the USF NewsArticle `speakable` cssSelector (THIN-1570) */}
      <h1 id="article-headline" className="text-header-2 lg:text-header-1 my-4">
        {article?.title || ""}
      </h1>

      {/* Standfirst */}
      {article?.standfirst && (
        <p
          id="article-summary"
          className="text-header-4 border-divider-secondary dark:border-divider-secondary-on-dark mb-4 border-t border-b py-4"
        >
          {article.standfirst || ""}
        </p>
      )}

      <div className="flex justify-between">
        <div className="flex items-center gap-3">
          {/* Date & Category Tag  */}
          <p className="text-secondary dark:text-secondary-on-dark text-label-2 font-bold">
            {formattedPublishDate}
          </p>

          <CategoryTag name={sectionName} href={`/${section}`} />
        </div>

        <div className="flex items-center gap-3">
          <GoogleSourceBtn className="hidden lg:flex" />

          <SocialShare viewType={isDesktopView ? "inline" : "dropdown"} />
        </div>
      </div>

      <GoogleSourceBtn className="mt-2 flex lg:hidden" />
    </div>
  );
}
